import { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import { pageUrl } from "src/network/fullUrl";
import { MainMenu } from "src/network/fetchFullMainMenu";
import { Link } from "react-router-dom";
 

interface MenuItemProps {
  menuItem: MainMenu;
}

const MenuItem: React.FC<MenuItemProps> = ({ menuItem }) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const navbarRef = useRef<HTMLDivElement | null>(null);
  const subMenuTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const openSubMenu = () => {
    if (subMenuTimeoutRef.current) {
      clearTimeout(subMenuTimeoutRef.current);
    }
    setIsSubMenuOpen(true);
  };

  const closeSubMenu = () => {
    subMenuTimeoutRef.current = setTimeout(() => {
      setIsSubMenuOpen(false);
    }, 100);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target as Node)
      ) {
        setIsSubMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
      if (subMenuTimeoutRef.current) {
        clearTimeout(subMenuTimeoutRef.current);
      }
    };
  }, []);

  return (
    <li
      className={`submenu-toggle ${isSubMenuOpen ? "active" : ""}`}
      onMouseEnter={openSubMenu}
      onMouseLeave={closeSubMenu}
    >
      <Link to={pageUrl(menuItem.url)} className="nav-link services-link">
        {menuItem.label}
      </Link>

      <span className="arrow" style={{ marginLeft: "5px" }}>
        &#9660;
      </span>

      {(menuItem.subMenu?.length ?? 0) > 0 && isSubMenuOpen && (
        <div className="sub-menu-container">
          <ul className="sub-menu">
            {menuItem.subMenu?.map((subItem) => (
              <li key={`sub-menu-desktop-${subItem.url}`}>
                <Link to={pageUrl(subItem.url)} className={"nav-sub-link"}>
                  {subItem.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  );
};

export default MenuItem;
